import styled from 'styled-components'

export const FAQContainer = styled.div``
